/**
 * Created by nemio on 27.11.2015.
 */

import moment from 'moment';
import ru from 'moment/locale/ru';

moment.updateLocale('ru_RU', {
  calendar : {
    lastDay : '[Вчера]',
    sameDay : '[Сегодня]',
    nextDay : '[Завтра]',
    lastWeek : '[На прошлой неделе в ] dddd',
    nextWeek : '[На следующей неделе в] dddd',
    sameElse : '[Ранее]'
  }
});

const ru_RU = {
  yes: 'Да',
  no: 'Нет',
  no_thanks: 'Нет, спасибо',
  loading: 'Загрузка...',
  global_error: 'Простите, сайт недоступен по техническим причинам . Попробуйте позже',
  email: 'Email',
  password: 'Пароль',
  close: 'Закрыть',
  favorites: 'Избранное',
  search: 'Поиск',
  related: 'Похожие',
  tv: 'ТВ Каналы',
  movies: 'Фильмы',
  tvseries: 'ТВ Сериалы',
  on_now: 'ЕПГ',
  cartoons: 'Мультфильмы',
  purchases: 'Покупки',
  premiere: 'Премьеры',
  my_services: {
    my_services: 'Мои Сервисы',
    my_rents: 'Мои покупки',
    my_subscriptions: 'Мои подписки',
    subscriptions: 'Подписка',
    rents: 'Прокат'
  },
  page: {
    home: 'Главная',
    epg: 'В Эфире',
    favorites: 'Избранное',
    notifications: 'Оповещения',
    records: 'Мои Зиписи',
    purchases: 'Мои Покупки',
    related: 'Похожие',
    search: 'Поиск',
    collection: 'Категория'
  },
  error: {
    invalid_credentials: 'Неверные логин / пароль',
    invalid_credentials_description: ' ',
    blocked_subscription: 'Дорогой пользователь, ваша подписка недоступна в данные момент. Пожалуйста, пополните счет. Спасибо',
    'invalid old password': 'Некорректный пароль',
    'passwords mismatch': 'Пароли должны совпадать',
    'username field empty': 'Поле Email не должно быть пустым',
    'already exist': 'Дынный Email уже зарегистрирован. Используйте другой адрес или Авторизируйтесь',
    'password field empty': 'Поле Пароль не должно быть пустым',
    'password too short': 'Длина пароля должна быть больше 6 символов. Можно использовать буквы, цифры и специальные символы',
    'invalid password reset code': 'Некорректный код подтверждения',
    'invalid ack': 'Некорректный код подтверждения',
    'invalid pin': 'Некорректный ПИН-код'
  },
  registration: {
    texts: {
      button: 'Создать аккаунт',
      title: 'Зарегистрируйся!',
      description: 'Если Вы еще не зарегистрированы, пожалуйста сделайте это'
    }
  },
  login: {
    login: 'Email',
    login_example: 'name@domain.com',
    lost_your_password: 'Забыли пароль?',
    logout: 'Выйти',
    log_in: 'Войти'
  },
  forgot_password: {
    login: 'Email',
    login_example: 'name@domain.com',
    lost_your_password: 'Забыли пароль?',
    forgot_password: 'Забыли пароль?',
    send: "Отправить",
    recovery_password: "Восстановить пароль",
    empty_field: "Пустое поле",
    wrong_email: "Некорректный пароль",
    reset_password_success_message: "Вы получите электронное письмо со ссылкой для сброса пароля",
    reset_password_error_message: "Некорректные данные",
  },
  profile: {
    movie: {
      bundle: 'Подписка',
      min: 'мин',
      fav_add: 'Добавить в избранное',
      fav_remove: 'Убрать из избранного',
      trailer: 'Трейлер',
      youtube_trailer: 'Youtube Трейлер',
      multiscreen: 'Продолжить на другом экране',
      related: 'Похожие',
      share: 'Поделиться',
      select_screen: 'Выбрать экран'
    },
    tvSeries: {
      bundle: 'Подписка',
      min: 'мин',
      fav_add: 'Добавить в избранное',
      fav_remove: 'Убрать из избранного',
      trailer: 'Трейлер',
      multiscreen: 'Продолжить на другом экране',
      related: 'Похожие',
      share: 'Поделиться',
      select_screen: 'Выбрать экран',
      seasons: 'Сезон',
      episodes: 'Эпизод',
      season_short: 'С', //S01E12
      episode_short: 'Эп.', //S01E12
    },
    channel: {
      calendar: {
        before: 'Перед этим',
        previously: 'Ранее',
        now: 'Сейчас',
        after: 'Затем',
        hereafter: 'Дальше',
        yesterday: 'Завтра',
        yesterday_at: 'Завтра в',
        today: 'Сегодня',
        today_at: 'Сегодня в',
        tomorrow: 'Завтра',
        tomorrow_at: 'Завтра в',
        last: 'Длительность'
      },
      epg: 'ЕПГ',
      bundle: 'Подписка',
      min: 'min',
      fav_add: 'Добавить в избранное',
      fav_remove: 'Убрать из избранного',
      record_add: 'Добавить в Запись',
      record_remove: 'Удалить из Записи',
      schedule_remove: 'Отменить Запись',
      multiscreen: 'Продолжить на другом экране',
      share: 'Поделиться',
      select_screen: 'Выбрать экран'
    },
    subscription: {
      subscription: 'Подписка',
      included: 'Состав',
      expires: 'Подписка до',
      bought: 'Куплено',
      owned: 'Мои покупки',
      subscription_period_end: 'Следующая оплата',
      subscription_period_start: 'Начало подписки',
      subscription_states: {
        active: 'Активен',
        trialing: 'Пробный период',
        unpaid: 'Ожидание оплаты',
        '_': 'Неизвестно'
      },
      canceled: 'Отменено',
      cancel: 'Отменить подписку',
      first_payment: 'Начало подписки',
      details: 'Подробнее',
      status: 'Статус',
      are_you_sure: 'Вы уверены',
      cancel_desc: 'что хотите отменить подписку для',
      re_subscribe: 'Возобновить подписку вы сможите только по окончанию текущего периода.',
      yes: 'Да',
      no: 'Нет'
    },
    packages: {
      included: 'Включает',
      expires: 'Подписка до',
      bought: 'Куплено',
      owned: 'Мои покупки'
    },
    epg_event: {
      remind_me: 'Напомнить',
      not_remind: 'Не напоминать',
      record_add: 'Добавить в Запись',
      record_remove: 'Удалить из Записи',
      schedule_remove: 'Отменить Запись'
    },
    notification: {
      remind_me: 'Напомнить',
      not_remind: 'Не напоминать',
    },
    npvr: {
      record_add: 'Добавить в Запись',
      record_remove: 'Удалить из Записи',
      schedule_remove: 'Отменить Запись'
    },
    ratings: {
      rating_delimiter: '/'
    },
    persons: {
      operator: 'Оператор',
      assembly: 'Монтаж',
      actor: 'Актер',
      director: 'Режиссер',
      scenario: 'Сценарий',
      composer: 'Композитор',
      presenter: 'Ведущий',
      music_director: 'Музыкальный Режиссер',
      playback_singers: 'Исполнитель',
      _: 'Другое'
    },
    offers: {
      type: {
        'free': 'Бесплатно',
        'transactional-own': 'Купить',
        'transactional-rent': 'Прокат',
        'subscription': 'Подписка',
        'transactional-own-bundle': 'Купить подписку',
        'transactional-rent-bundle': 'Взять на прокат по подписке',
        'subscription-bundle': 'Подписаться на подписку',
        '_': 'Другое'
      },
      pay_as_you_go: 'Предложения о покупке',
      select_bundle: 'Выбрать подписку',
      or: 'или',
      free_trial: 'Бесплатный период',
      free_trial_description: 'После окончания бесплатного периода с Вашего аккаунта будет списана абоненская плата',
      unit: {
        hour: 'Час',
        day: 'День',
        week: 'Неделя',
        month: 'Месяц',
        year: 'Год',
      }
    }
  },
  player: {
    no_signal: 'Нет сигнала',
    reload: 'Перезагрузить',
    youtube_connection_error: 'Ошибка подключения к Youtube'
  },
  more_menu_items: 'Еще',
  empty_section: 'В данном разделе пусто',
  empty_result: 'К сожалению, по вашему запросу ничего не найдено',
  epg: {
    no_data: 'Нет данных за этот период',
    now: 'Сейчас',
    today: 'Сегодня'
  },
  npvr: {
    filters: {
      status: 'Сортировать по статусу',
      date: 'Сортировать по дате',
      alphabet: 'Сортировать по названию',
      channel: 'Сортировать по каналу'
    },
    status: {
      pending: 'В очереди',
      scheduled: 'Запланировано',
      recording: 'В процессе',
      finished: 'Записано',
      failed: 'Ошибка',
      cancelled: 'Отменено пользователем'
    },
    usage: 'Использовано',
    limit_desc: 'Как только вы достигните лимита, новые передачи не будут записываться',
    limit_desc_warning: 'Вы почти исчерпали доступный лимит',
    limit_desc_reached: 'Перед тем как ставить на запись передачу, вам предется удалить старые или уже просмотренные'
  },
  genres: 'Жанры',
  messages: {
    pin: {
      title: 'Введите ПИН-код',
      ok: 'OK',
      cancel: 'Отмена'
    },
    notification: {
      title: 'Напоминание ',
      on_channel: 'на канале',
      is_switch_show_right_now: 'начнется через 5 минут. Хотите переключиться сейчас?'
    },
    share_request: {
      title: 'Поделиться ',
      vod: 'видео',
      live: 'канал',
      you_have_received: 'Вы получили оповещение ',
      sharing_notification: '. Вы хотите его посмотреть?'
    },
    bookmark: {
      title: 'Продожить просмотр?',
      continue_from: 'Продолжить с',
      start_over: 'Начать с начала'
    }
  },
  settings: {
    settings: 'Настройки',
    tabs: {
      login: {
        title: 'Авторизация',
        email: 'Email',
        password: 'Пароль',
        sign_in: 'Войти',
        error: 'Неверный логин / пароль',
        success: 'Спасибо что вернулись!'
      },
      registration: {
        title: 'Регистрация',
        email: 'Email',
        password: 'Пароль',
        password2: 'Повторить пароль',
        first_name: 'Имя',
        last_name: 'Фамилия',
        sign_up: 'Войти',
        success: "Спасибо за регистрацию!",
        need_confirmation: "На Ваш email отправлено письмо. Пройдите пожалуйста по ссылке в письме для активации Вашего аккаунта.",
      },
      registration_confirm: {
        success: "Спасибо Вам за регистрацию. Вы можете использовать Ваш логин и пароль на других устройствах если данная услуга подключена."
      },
      language: {
        title: 'Язык',
        select_language: 'Выбор языка:'
      },
      parental_control: {
        title: 'Родительский контроль',
        description: 'Включить родительский контроль',
        on: 'Вкл',
        off: 'Выкл'
      },
      change_password: {
        title: 'Сменить пароль',
        save: 'Сохранить',
        old_password: 'Старый пароль',
        new_password: 'Новый пароль',
        new_password2: 'Повторить пароль',
        success: 'Пароль успешно обновлен'
      },
      reset_password: {
        title: 'Сбрость пароль',
        save: 'Сохранить',
        enter_new_password: 'Введите новый пароль',
        ack: 'Код подтверждения',
        password: 'Новый пароль',
        success: 'Пароль успешно обновлен'
      },
    },
  },
  toast: {
    type: {
      record: 'Запись',
      favorite: 'Избранное',
      notification: 'Оповещения',
      purchase: 'Покупки',
      service: 'Сервис',
      cookies: 'Файлы Cookie',
      adblock: 'Ad block'
    },
    operation: {
      record_add_success: 'Успешная постановка на запись',
      record_add_fail: 'Неуспешная постановка на запись',
      record_remove_success: 'Успешная удаление записи',
      record_remove_fail: 'Успешная отмена записи',
      favorite_add_success: 'Успешно добавлен',
      favorite_add_fail: 'Ошибка добавления',
      favorite_remove_success: 'Успешно удален',
      favorite_remove_fail: 'Ошибка удаления',
      notification_add_success: 'Успешно добавлено',
      notification_add_fail: 'Ошибка добавления',
      notification_remove_success: 'Успешно удалено',
      notification_remove_fail: 'Ошибка при удалении',
      purchase_add_success: 'Операция завершена успешно',
      purchase_add_fail: 'Отказ в операции',
      purchase_remove_success: 'Операция завершена успешно',
      purchase_remove_fail: 'Отказ в отмене',
      service_unstable_connection: 'Связь с сервером прервана',
      enable_cookies: 'Пожалуйста, включите поддержку файлов cookie',
      disable_adblock: 'Ad block может повлиять на функциональность сайта. ' +
      'Пожалуйста, добавьте нас в исключения.'
    }
  }
};

export default ru_RU;



// WEBPACK FOOTER //
// ./src/locales/dics/ru_RU.js